let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bF2Yj")).then(() => parcelRequire('h2Mqp'));